<template>
  <div v-if="show" class="row">
    <div class="form-group">
      <div class="progress"
  >
    <div id="progress-bar"
         class="progress-bar progress-bar-success progress-bar-striped active"
         role="progressbar"
         :style="{width: percentage+'%'}"
         :aria-valuenow="percentage"
         aria-valuemin="0"
         aria-valuemax="100"
    >
      {{percentage}}%
    </div>
  </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "ProgressBar",
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style scoped>

</style>